module.exports = __webpack_public_path__ + "./static/img/icondis-5.0335ca744d688729f6a0438030b5dd25.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-5.png
// module id = ./client/src/assets/img/company/icondis-5.png
// module chunks = 0